import React from 'react';
import ReactDOM from 'react-dom/client';

import { Provider } from 'react-redux';
import store from 'store';
import 'fix-date';
import './index.css';
import './main.css';
// import './ckeditor.css';
import 'react-datepicker/dist/react-datepicker.css';
import { CONF_DSN_SENTRY, CONF_ENVIRONMENT, CONF_API_URL } from 'utils/config';

// sentry tracker
import * as Sentry from '@sentry/react';

// app
import App from './App';
import AppProvider from 'ApolloProvider'; // Will be removed when Apollo is removed
import reportWebVitals from './reportWebVitals';
import ConfirmDialog from 'components/modals/ModalConfirm';

// tanstack query
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// init Sentry
Sentry.init({
  dsn: CONF_DSN_SENTRY,
  environment: CONF_ENVIRONMENT || 'development',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true
    })
  ],

  // Trace API calls to your backend
  tracePropagationTargets: CONF_API_URL ? [new URL(CONF_API_URL).hostname] : [],

  // Performance monitoring - lower in production to reduce costs
  tracesSampleRate: CONF_ENVIRONMENT === 'production' ? 0.1 : 1.0,

  // Only send events in production
  beforeSend(event, hint) {
    if (CONF_ENVIRONMENT !== 'production') {
      console.log('[Sentry] Event captured in non-prod:', event);
      return null; // Don't send to Sentry
    }
    return event;
  },

  // Ignore common non-critical errors
  ignoreErrors: ['ResizeObserver loop limit exceeded', 'Non-Error promise rejection captured']
});

// initialise TanStack Query client
const queryClient = new QueryClient();

const container = document.getElementById('root');
if (!container) throw new Error('Root container missing in index.html');
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    {/* ApolloProvider will be removed later */}
    <AppProvider>
      {/* @ts-expect-error Property 'refs' is missing in type 'Provider<any>' but required in type 'Component<any, any, any>'.ts(2786) */}
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <App />
          <ConfirmDialog />
        </QueryClientProvider>
      </Provider>
    </AppProvider>
  </React.StrictMode>
);

// CRA performance reporting
reportWebVitals();
